export const COLOR_PALETTE = ['#df703d', '#ec9b77', '#f3c6b2', '#f1f1f1', '#d3d2d3', '#b5b5b7', '#99989b'];

export default {};
